import React, { useEffect } from "react";
import { useState } from "react";
import { MovieTag } from "./MovieTag.js";
import "./movie_tag.css";

export const MovieTagList = (props) => {
    const { movieItems, layoutType } = props;

    let movieType = props.movieType? props.movieType : "mov";

    const [isGrid, setGrid] = useState(true);
    const [focusItem, setFocusItem] = useState(null);

    function handleSwitchLayout() {
      setGrid(!isGrid ? true : false);
      setFocusItem(null);
    }

    function handleMouseEnter(movieId) {
      setFocusItem(movieId);
    }

    function handleMouseLeave() {
      setFocusItem(null);
    }

    useEffect(() => {
      setGrid(layoutType === "grid")
      setFocusItem(null);
    }, [layoutType])

    return (
      <div className="mov_tag list_container">
        <div className={`list_of_mov_tag ${isGrid ? "grid_tag" : ""}`}>
          {movieItems.map((item, index) => (
            <div className={`list_item ${isGrid ? "grid_tag" : ""}`}>
              <MovieTag
                idx={index}
                isGrid={isGrid}
                isDefaultSmall={true}
                isHoverEnable={true}
                listControl={{
                  detailData: item,
                  handleMouseEnter: handleMouseEnter,
                  handleMouseLeave: handleMouseLeave,
                  focusItem: focusItem,
                  setFocusItem: setFocusItem,
                  movieId: item.id,
                  movieType: movieType,
                }}
              />
            </div>
          ))}
        </div>
      </div>
    );
}
